import { render, staticRenderFns } from "./Learn.vue?vue&type=template&id=d8ddc0ae&scoped=true&"
import script from "./Learn.vue?vue&type=script&lang=js&"
export * from "./Learn.vue?vue&type=script&lang=js&"
import style0 from "./Learn.vue?vue&type=style&index=0&id=d8ddc0ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ddc0ae",
  null
  
)

export default component.exports